module.exports = __webpack_public_path__ + "static/img/douyin_qrcode.18de5f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/douyin_qrcode.jpg
// module id = wZR0
// module chunks = 1